/**
 * Адрес сайта из карточки или заявки: их вводят пользователи, поэтому наружу пускаем только
 * обычную ссылку на сайт. Остальные схемы (например, javascript:) возвращают null.
 */
export const safeHttpHref = (value: string | null) => {
  if (!value) {
    return null
  }
  try {
    const url = new URL(value)

    return url.protocol === 'http:' || url.protocol === 'https:' ? value : null
  } catch {
    return null
  }
}
